module.exports = __webpack_public_path__ + "img/mobile_banner.32cf090c.jpg";